import { createSlice } from "@reduxjs/toolkit";
import { transformObjectToKeyValueArray } from "../../../utilities/commonUtilities";
import { othersInput } from "../../model/jetlift/jetlift";

interface othersState {
    loading: boolean;
    error: string | undefined;
    othersInput: othersInput | null;
}

export const initialState: othersState = {
    loading: false,
    error: "",
    othersInput: null,
};

const OthersSlice = createSlice({
    name: "jetlift/others",
    initialState,
    reducers: {
        resetOthersTab: () => ({
            ...initialState
        }),
        setOtherDetails: (state, action) => {
            const payload = action?.payload;
            if (payload) {
                state.othersInput = {
                    ...payload,
                    suplPwrList: payload.suplPwrList ? transformObjectToKeyValueArray(payload?.suplPwrList) : [],
                    contrlList: payload.contrlList ? transformObjectToKeyValueArray(payload?.contrlList) : []
                };
            }
        },
        setSupplyPower(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    suplPwrListVal: action.payload
                };
            }
        },
        setSupplyVoltage(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    suplVlt: action.payload
                };
            }
        },
        setAvailableKVA(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    availKVA: action.payload
                };
            }
        },
        setSupplyPowerList(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    suplPwrList: action?.payload && Object?.keys(action.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : [],
                }
            }
        },
        setControllerList(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    contrlList: action?.payload && Object?.keys(action?.payload)?.length > 0 ? transformObjectToKeyValueArray(action?.payload) : []
                }
            }
        },
        setController(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    unitContrlListVal: action.payload
                };
            }
        },

        setOxygen(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    oxygenVal: action.payload
                };
            }
        },
        setNitrogen(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    nitrogenVal: action.payload
                };
            }
        },
        setH2S(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    h2S: action.payload
                };
            }
        },
        setCO2(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    cO2: action.payload
                };
            }
        },
        setCorrosion(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    unitCorsnListVal: action.payload
                };
            }
        },
        setParaffin(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    paraffin: action.payload
                };
            }
        },
        setScale(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    scale: action?.payload
                };
            }
        },
        setSandSolids(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    sandSolids: action.payload
                };
            }
        },
        setViscosityEmulsion(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    viscostyEmulsn: action.payload
                };
            }
        },
        setPacker(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    packerReqd: action.payload
                };
            }
        },
        setChemical(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    chemicalYN: action.payload
                };
            }
        },
        setYTool(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    yToolYN: action.payload
                };
            }
        },
        setScdaCompatibility(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    scadayn: action.payload
                };
            }
        },
        setPressureSensor(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    pressureSensYN: action.payload
                };
            }
        },
        setNotes(state, action) {
            if (state.othersInput) {
                state.othersInput = {
                    ...state.othersInput,
                    additnalNotes: action.payload
                };
            }
        }
    },
});

export const {
    resetOthersTab,
    setOtherDetails,
    setSupplyPower,
    setSupplyPowerList,
    setControllerList,
    setSupplyVoltage,
    setAvailableKVA,
    setController,
    setOxygen,
    setNitrogen,
    setH2S,
    setCO2,
    setCorrosion,
    setParaffin,
    setScale,
    setSandSolids,
    setViscosityEmulsion,
    setPacker,
    setChemical,
    setYTool,
    setScdaCompatibility,
    setPressureSensor,
    setNotes,
} = OthersSlice.actions;

export default OthersSlice.reducer;
